import { creatorbase, tiktok } from '@round/api';
import { PlatformPostData } from './PlatformPost';
import { buildTiktokPostUrl, buildTiktokUserUrl } from 'helpers';

export const mapTikTokPostToPlatformPostData = (
    post: creatorbase.TiktokPost<true>,
    stats?: tiktok.TiktokUserStatsCache
): PlatformPostData => {
    const authorUsername = post.tiktok_details?.author_username ?? null;
    const platformId = post.tiktok_details?.content_tiktok_id ?? null;

    return {
        id: post.id,
        platform: post.platform,
        viewCount: post.view_count,
        commentCount: post.tiktok_details?.comment_count ?? null,
        shareCount: post.tiktok_details?.share_count ?? null,
        likeCount: post.tiktok_details?.like_count ?? null,
        saveCount: post.tiktok_details?.save_count ?? null,
        adCode: post.tiktok_details?.ad_code ?? '',
        platformId,
        platformUrl: platformId && authorUsername ? buildTiktokPostUrl(authorUsername, platformId) : null,
        authorUsername,
        authorNickname: post.tiktok_details?.author_nickname ?? null,
        authorProfileUrl: authorUsername ? buildTiktokUserUrl(authorUsername) : null,
        description: post.tiktok_details?.description ?? null,
        createdDate: post.upload_date,
        countryCode: post.tiktok_details?.author_country ?? null,
        coverImageUrl: post.tiktok_details?.cover_image_url ?? '',
        videoPlayUrl: post.tiktok_details?.video_play_url ?? null,
        audioId: post.tiktok_details?.audio_id ?? null,
        audioTitle: post.tiktok_details?.audio_title ?? null,
        audioAuthorName: post.tiktok_details?.audio_author_name ?? null,
        audioIsOriginal: post.tiktok_details?.audio_is_original ?? null,
        followerCount: stats?.follower_count ?? null,
    };
};
